import clsx from 'clsx';

import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

interface TimeframeInfoProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function TimeframeInfo({
  title,
  children,
  className,
}: TimeframeInfoProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-start justify-center gap-2',
        className,
      )}
    >
      <Typography variant="caption">{title}</Typography>
      {children}
    </div>
  );
}

TimeframeInfo.Skeleton = function TimeframeInfoSkeleton({
  title,
}: {
  title: string;
}) {
  return (
    <div className="flex w-[84px] flex-col items-start justify-center gap-2">
      <Typography variant="caption">{title}</Typography>
      <Skeleton className="mt-1 h-4 w-20" />
    </div>
  );
};
